/*! Wi-timeline - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var url_timeline, url_timeline_delete, url_timeline_save;
+function ($) {
    'use strict';
    var wiTimeline = window.wiTimeline;
    window.wiTimeline = {
        init: function () {
            wiTimeline.events();
        },
        refresh: function () {
        },
        events: function () {
            $(document).on('show.bs.tab', '.tab-timeline', function () {
                var ajaxloaded = $(this).attr('data-ajax-loaded');
                if (ajaxloaded === 'false') {
                    $(this).attr('data-ajax-loaded', true);
                    wiVars.set.variable('subreferral_id', 0);
                    wiVars.set.variable('subreferral_type', '');
                    wiVars.set.variables();
                    wiTimeline.get.timeline();
                }
            });

            $(document).on('show.bs.tab', '.tab-section-timeline', function () {
                subreferral_id = $(this).attr('data-subreferral-id');
                subreferral_type = $(this).attr('data-subreferral-type');
                var ajaxloaded = $(this).attr('data-ajax-loaded');
                $('#subreferral_id').val(subreferral_id);
                $('#subreferral_type').val(subreferral_type);
                if (ajaxloaded === 'false') {
                    $(this).attr('data-ajax-loaded', true);
                    wiVars.set.variables();
                    wiTimeline.get.timeline();
                }
            });
        },
        get: {
            timeline: function () {
                $.get(
                        url_timeline,
                        {
                            referral_id: referral_id,
                            referral_type: referral_type,
                            subreferral_id: subreferral_id,
                            subreferral_type: subreferral_type,
                            csrf_wicode: csrf_value
                        },
                        function (data) {

                            var timeline_area = $('#timeline_area');
                            timeline_area.html(data.timeline);

                            setInterval(function () {
                                //wiTimeline.get.messages();
                            }, 2000);
                        }
                );
            }
        }
    };
    $(function () {
        url_timeline = urls.timeline + '/get_timeline';

        wiTimeline = window.wiTimeline;
        wiTimeline.init();
    });
}(jQuery);
